import React from "react";
import { getPresenceLabel } from "./trapSkuConfig";

// Словник для назв кнопок-фільтрів
const subjectTypeMap = {
  trap_price: "Ціни",
  trap_category: "Категорії",
  trap_presence: "Наявність",
};

// Словник для назв дій
const actionTypeMap = {
  trap_price_updated: "Змінив(ла) ціну",
  trap_custom_price_updated: "Встановив(ла) кастомну ціну",
  trap_custom_price_deleted: "Скинув(ла) кастомну ціну",
  trap_category_updated: "Змінив(ла) категорію",
  trap_presence_updated: "Змінив(ла) наявність",
};

// Словник для назв полів у 'properties'
const propertyKeyMap = {
  price: "Ціна",
  custom_price: "Кастомна ціна",
  category_name: "Категорія",
  presence: "Наявність",
};

// Людяне відображення значення поля
const formatValue = (key, value) => {
  if (value === null || value === undefined || value === "") return "пусто";
  if (key === "presence") return value === "auto" ? "Авто" : getPresenceLabel(value);
  return value;
};

/**
 * Спеціальна функція-рендер для відображення 'properties'.
 * Бекенд завжди пише пару old_values → new_values, тож рендер один для всіх дій.
 */
const renderPropertyChanges = (properties) => {
  const { new_values = {}, old_values = {} } = properties || {};

  return (
    <ul className="history-item__changes">
      {Object.keys(new_values).map((key) => (
        <li key={key}>
          <strong>{propertyKeyMap[key] || key}: </strong>
          <span className="old-value">{formatValue(key, old_values[key])}</span>
          <span> → </span>
          <span className="new-value">{formatValue(key, new_values[key])}</span>
        </li>
      ))}
    </ul>
  );
};

export const trapHistoryConfig = {
  subjectTypeMap,
  actionTypeMap,
  renderPropertyChanges,
};
